import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideSocketIo } from 'ngx-socket-io';
import { provideToastr } from 'ngx-toastr';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { SNACKBAR_DEFAULTS } from './shared/constants/snackbar-default-config.const';
import { TOASTR_GLOBAL_CONFIG } from './shared/constants/toastr-global-config.const';
import { SOCKET_CONFIG } from './shared/constants/websocket-config.const';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideSocketIo(SOCKET_CONFIG),
    provideToastr(TOASTR_GLOBAL_CONFIG),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: SNACKBAR_DEFAULTS,
    },
    provideCharts(withDefaultRegisterables()),
  ],
};
